'use client'

import { createContext, useContext, type ReactNode } from 'react'

export type CloudflareConfig = {
  enabled: boolean
  cfDomain: string
  internalDomain: string
  cmsDomain: string
}

const CloudflareConfigContext = createContext<CloudflareConfig | null>(null)

export function CloudflareConfigProvider({
  children,
  config,
}: {
  children: ReactNode
  config: CloudflareConfig
}) {
  return (
    <CloudflareConfigContext.Provider value={config}>{children}</CloudflareConfigContext.Provider>
  )
}

export function useCloudflareConfig(): CloudflareConfig {
  const context = useContext(CloudflareConfigContext)

  if (!context) {
    throw new Error('useCloudflareConfig must be used within a CloudflareConfigProvider')
  }

  return context
}
